import React from "react";
import {Link, Outlet} from "react-router-dom";

const MainLayout: React.FC = (): JSX.Element => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default MainLayout;
